import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {

    state = {
        from: this.props.from,
        to: this.props.to,
        minimum: this.props.minimum,
        maximun: this.props.maximun
    }

    handleClose = (from, to, minimum, maximun) => (event) => {
        this.props.onClose(from, to, minimum, maximun);
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };


    render() {
        const { from, to, minimum, maximun } = this.state;
        const { intl } = this.props
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(undefined, undefined, 1, 5)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders margin_top_24'}>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            defaultValue={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            defaultValue={to}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'sts_survey_score_minimum' })}
                            </InputLabel>
                            <Select
                                required
                                native
                                value={minimum}
                                name={'minimum'}
                                onChange={this.handleChange}
                                inputProps={{ name: 'minimum', id: 'minimum-id' }}
                            >
                                <option key={randomstring()} value={1}>1</option>
                                <option key={randomstring()} value={2}>2</option>
                                <option key={randomstring()} value={3}>3</option>
                                <option key={randomstring()} value={4}>4</option>
                                <option key={randomstring()} value={5}>5</option>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'sts_survey_score_maximum' })}
                            </InputLabel>
                            <Select
                                required
                                native
                                value={maximun}
                                name={'maximun'}
                                onChange={this.handleChange}
                                inputProps={{ name: 'maximun', id: 'maximun-id' }}
                            >
                                <option key={randomstring()} value={1}>1</option>
                                <option key={randomstring()} value={2}>2</option>
                                <option key={randomstring()} value={3}>3</option>
                                <option key={randomstring()} value={4}>4</option>
                                <option key={randomstring()} value={5}>5</option>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(undefined, undefined, 1, 5)} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button onClick={this.handleClose(from, to, minimum, maximun)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/reports/sts/FilterMenu.js